import { forwardRef } from "react";
import Flame from "lucide-react/dist/esm/icons/flame";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface EarlyFounderBadgeProps {
  size?: "sm" | "md" | "lg";
  showTooltip?: boolean;
  className?: string;
}

export const EarlyFounderBadge = forwardRef<HTMLSpanElement, EarlyFounderBadgeProps>(
  ({ size = "sm", showTooltip = true, className }, ref) => {
    const sizeClasses = {
      sm: "h-4 w-4",
      md: "h-5 w-5",
      lg: "h-6 w-6",
    };

    const badgeSizes = {
      sm: "px-1.5 py-0.5 text-2xs gap-1",
      md: "px-2 py-0.5 text-xs gap-1",
      lg: "px-2.5 py-1 text-xs gap-1.5",
    };

    const badge = (
      <span
        className={cn(
          "inline-flex items-center rounded-full font-semibold uppercase tracking-wider",
          // Uses accent token (orange-gold) — the "prestige" signal for founder status
          "bg-accent/15 text-accent border border-accent/30",
          badgeSizes[size],
          className
        )}
      >
        <Flame className={cn(sizeClasses[size], "fill-accent/40")} />
        Founder
      </span>
    );

    if (!showTooltip) {
      return <span ref={ref} className="inline-flex">{badge}</span>;
    }

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span ref={ref} className="inline-flex">{badge}</span>
        </TooltipTrigger>
        <TooltipContent>
          <p>Early Founder — one of our first sellers on the platform</p>
        </TooltipContent>
      </Tooltip>
    );
  }
);

EarlyFounderBadge.displayName = "EarlyFounderBadge";
